// extracted by mini-css-extract-plugin
module.exports = {"revision-item":"revision-list-entry_revision-item__o_ulW"};